<template>
  <div id="app">
    <v-app>
      <v-container fluid fill-height>
        <v-layout fill-height>
          <v-flex md6>
            <v-card class="mx-auto" dark tile flat color="#E9FBF8" style="height: 100%; width: 100%">
              <slot></slot>
            </v-card>
          </v-flex>
          <v-flex md6 class="mobileOnly">
            <v-parallax class="leftBackground" height="100%"></v-parallax>
          </v-flex>
        </v-layout>
      </v-container>
    </v-app>
  </div>
</template>
<script>
import AppMenu from "../Menu"
export default {
  name: 'LoginLayout',
  components: { 'app-menu': AppMenu },
  data() {
    return {
      drawer: null,
      items: [
        { title: 'Home', icon: 'dashboard' },
        { title: 'About', icon: 'question_answer' }
      ],
      signedIn: false,
      admin: false
    }
  },
  methods: {
    signOut() {
      this.$cookies.remove('api_token')
      this.$cookies.remove('email')
      this.$cookies.remove('name')
      this.$cookies.remove('admin')
      this.signedIn = false
      this.$router.push('/')
    },
    logoClick() {
      if (this.signedIn) {
        this.$router.push('/dashboard')
      } else {
        this.$router.push('/')
      }
    }
  },
  mounted() {
    this.signedIn = this.$cookies.isKey('api_token') && this.$cookies.get('api_token') !== ''
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
  }
}
</script>
<style scoped>
@import url("https://use.typekit.net/gbx5lto.css");
@media (max-width: 959px) {
 .mobileOnly {
   display:none;
  }
}

@media (max-width: 959px) {
 .mobileOnly {
   display:none;
  }
}
.container{
  padding:0
}
.leftBackground, .gridBackground, .gridBackground2{
  background: url(/static/img-login-facilita-pay.png) no-repeat center center scroll;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  height: 100%;
  width: 100%;
  overflow: hidden;
}
.gridBackground{
  background: url(/static/img-login-facilita-pay.png) no-repeat center center scroll;
}

.gridBackground2{
  background: url(/static/img-login-facilita-pay.png) no-repeat center center scroll;
}
* {
  font-family: DM Sans;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 24px;
  letter-spacing: -0.05em;
  text-align: center;
}

.theme--light.application {
  background-color: var(--background-color);
  /* background: linear-gradient(90deg, rgba(9,47,79,1) 0%, rgba(9,47,79,1) 42%, rgba(70, 139, 147, 1) 100%); */
  color: var(--primary-dark-font-color);
}

.v-text-field--box .v-input__slot {
  border-bottom-left-radius: 2px;
  border-top-right-radius: 0px;
}

.app-navigation { height: 60px; background-color: var(--navigation-color); }
.app-footer-disabled { position: absolute; left: 0px; bottom: -20px;}

body { padding: 0px; margin: 0px; }

body,
div.maxTitle-height { height: 100%;  }

.maxTitle-width-1200 { max-width: 1200px; }

.maxTitle {
  position: absolute;
  left: 0;
  right: 0;
  top: 55%;
  bottom: 0;
  font-weight: 700;
  font-size: 50px;
  line-height: 1.2;
  color: white;
  text-transform: none;
}
.font-blue { color: var(--text-dot-color) }

h4 { font-weight: 300; }

.btn-style, .btn-style--secondary, .btn-style--tertiary, .btn-style--gray {
  height: 56px;
  font-weight: 700;
}
.btn-style {
  background-color: var(--primary-button-background-color);
}
.btn-style--secondary {
  background-color: var(--secondary-button-background-color) !important;
}
.btn-style--tertiary {
  background-color: var(--tertiary-button-background-color);
}
.btn-style--gray {
  background-color: var(--dark-blue)!important;
  color: var(--silver-color-font-color);
}

.card-title-text {
  flex: 1;
  display: flex;
  justify-content: center;
  color: var(--background-color);
}

.input-control-with-grow > .v-input__control {
  flex-grow: 1;
}

/* v-autocomplete changes to match the appearence of other fields */
.v-autocomplete.v-input>.v-input__control>.v-input__slot {
  padding: 0 12px;
}

.v-input.v-text-field.v-autocomplete {
  margin: 0px;
  padding: 0px;
}
.v-input.v-text-field.v-autocomplete input {
  margin-top: 22px;
}
.v-text-field.v-autocomplete>.v-input__control>.v-input__slot {
  align-items: stretch;
  min-height: 56px;
}
.v-text-field.v-autocomplete .v-text-field__details {
  margin-bottom: 8px;
  padding-left: 10px;
}
.v-text-field.v-autocomplete .v-label {
  top: 18px;
}
.v-text-field.v-autocomplete .v-label--active {
  transform: translateY(-6px) scale(.75);
}
.v-text-field.v-autocomplete .v-input__append-inner {
  align-self: center;
}
.v-text-field.v-autocomplete>.v-input__control>.v-input__slot:before {
  border-width: thin 0;
}
.toolbar-btn {
  color: var(--background-color);
}

/*Animations*/

.fade-enter-active {
  transition: all .9s ease;
}
.fade-leave-active {
  transition: all .0s ease;
}
.fade-enter {
  opacity: 0;
}
.fade-leave-to {
  opacity: 0;
}
.arrow-icon-small {
  height: 14px;
  margin: 0px;
  padding: 0px;
  width: 12px;
  font-size: 14px;
}

.mx-auto {
  margin-left: auto;
  margin-right: auto;
}
</style>



// WEBPACK FOOTER //
// src/layouts/LoginLayout.vue